import moment from "moment-timezone";

/**
 * Convert UTC time → Property local time (12-hour format)
 */
export const toPropertyTime12h = (time, timeZone) => {
  if (!time) return "";

  // If it's already time-only like "06:00 PM"
  if (typeof time === "string" && time.includes("AM") || time.includes("PM")) {
    return moment(time, "hh:mm A").format("hh:mm A");
  }

  // If it's UTC datetime
  return moment.utc(time).tz(timeZone).format("hh:mm A");
};
/**
 * Convert UTC time → Property time (for <input type="time"> which needs 24h)
 */
export const utcToPropertyTime24h = (time, timeZone) => {
  if (!time) return "";

  if (typeof time === "string" && (time.includes("AM") || time.includes("PM"))) {
    return moment(time, "hh:mm A").format("HH:mm");
  }

  return moment.utc(time).tz(timeZone).format("HH:mm");
};

/**
 * Convert Property time → UTC (for API save)
 */
export const propertyTimeToUtc = (time, timeZone) => {
  if (!time) return null;

  // time is ALWAYS "06:00 PM"
  return moment
    .tz(time, "hh:mm A", timeZone)
    .utc()
    .format("hh:mm A");
};